import React from "react";
import { LinkType } from "./link/type";
import { useElementAppearsOnScreen } from "../../../hooks/use-element-on-screen";
import styles from "./styles.modules.scss";

export const Navigation = ({
    Link,
    prevLinkProps,
    nextLinkProps,
    shouldAnimate,
}: {
    Link: (props: LinkType) => JSX.Element;
    prevLinkProps?: LinkType;
    nextLinkProps?: LinkType;
    shouldAnimate?: boolean;
}) => {
    const [navRef, isInView] = useElementAppearsOnScreen<HTMLDivElement>({
        threshold: 0.1,
    });

    return prevLinkProps || nextLinkProps ? (
        <div
            ref={navRef}
            className={`navigationWrapper ${styles.navigationWrapper} ${shouldAnimate ? styles.animateIn : ""}`}
        >
            <div
                className={`navigation ${styles.navigation} ${
                    isInView && shouldAnimate ? styles.animate : ""
                } ${shouldAnimate ? styles.animateIn : ""}`}
            >
                {prevLinkProps && (
                    <div className={`prev ${styles.prev}`}>
                        <Link
                            {...prevLinkProps}
                            disabled={prevLinkProps.disabled}
                        />
                    </div>
                )}

                {nextLinkProps && (
                    <div className={`next ${styles.next}`}>
                        <Link
                            {...nextLinkProps}
                            next
                            disabled={nextLinkProps.disabled}
                        />
                    </div>
                )}
            </div>
        </div>
    ) : null;
};
